import React, { useState, useEffect } from 'react';
import './Sanad.css';
import SanadCarousel from '../../components/SanadCarousel/SanadCarousel';
import BookSwiper from '../../components/BookSwiper/BookSwiper';
import Footer from '../../components/Footer/Footer';

const Sanad = () => {
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'KU';
  });

  useEffect(() => {
    const savedLang = localStorage.getItem('selectedLanguage') || 'KU';
    setCurrentLang(savedLang);

    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
      localStorage.setItem('selectedLanguage', event.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const content = {
    EN: {
      title: 'Sanad'
    },
    KU: {
      title: 'سەنەد'
    },
    AR: {
      title: 'سند'
    },
    TR: {
      title: 'Sanad'
    }
  };

  const pageContent = content[currentLang] || content.KU;

  return (
    <div className="sanad-page">
      <div className="container">
        <div className="sanad-content">
          {/* Title */}
          <div className="sanad-title-section">
            <h1 className="page-title">{pageContent.title}</h1>
          </div>

          {/* Carousel Section */}
          <div className="sanad-carousel-section">
            <SanadCarousel />
          </div>

          {/* Book Swiper Section */}
          <div className="sanad-books-section">
            <BookSwiper />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Sanad;

